import { render, staticRenderFns } from "./ProfQualDetails.vue?vue&type=template&id=a1ae7d22&scoped=true"
import script from "./ProfQualDetails.vue?vue&type=script&lang=js"
export * from "./ProfQualDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfQualDetails.vue?vue&type=style&index=0&id=a1ae7d22&prod&scoped=true&lang=css"
import style1 from "./ProfQualDetails.vue?vue&type=style&index=1&id=a1ae7d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae7d22",
  null
  
)

export default component.exports